import './fdx-redirect.styles.scss';
import FdxRedirectController from './fdx-redirect.controller.js';

angular.module('feedAuthApp').component('fdxRedirect', {
    template: require('./fdx-redirect.template.html'),
    controller: FdxRedirectController
});